(() => {
  if (window.tdHeaderSearchRuntime) {
    window.tdHeaderSearchRuntime.init();
    return;
  }

  const aliases = new Map([
    ['rampla', 'rampa'], ['ranpa', 'rampa'], ['escalera', 'rampa'],
    ['escaleras', 'rampa'], ['unas', 'limador'], ['lima', 'limador']
  ]);
  const normalize = (value) => {
    const cleaned = value.trim().replace(/\s+/g, ' ');
    const key = cleaned.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    return aliases.get(key) || cleaned;
  };
  const words = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(/[a-z0-9]+/g) || [];

  class HeaderSearch {
    constructor(dialog) {
      this.dialog = dialog;
      this.input = dialog.querySelector('input[name="q"]');
      this.form = dialog.querySelector('form');
      this.results = dialog.querySelector('[data-td-search-results]');
      this.discover = dialog.querySelector('[data-td-search-discover]');
      this.status = dialog.querySelector('[role="status"]');
      this.clear = dialog.querySelector('[data-td-search-clear]');
      this.all = dialog.querySelector('[data-td-search-all]');
      this.events = new AbortController();
      this.cache = new Map();
      this.sequence = 0;
      this.timer = null;
      this.request = null;
      this.opener = null;
      this.locked = false;
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', () => this.onInput(), options);
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          const first = this.results.querySelector('a[data-td-search-product]');
          if (first && !this.results.hidden) {
            event.preventDefault();
            first.focus();
          }
        }
      }, options);
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.onInput();
        this.input.focus();
      }, options);
      dialog.querySelector('[data-td-search-close]').addEventListener('click', () => this.close(), options);
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }, { ...options, capture: true });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      dialog.addEventListener('close', () => this.cleanup(), options);
      dialog.addEventListener('click', (event) => this.onClick(event), options);
      this.form.addEventListener('submit', (event) => this.onSubmit(event), options);
    }

    track(event, detail = {}) {
      document.dispatchEvent(new CustomEvent('td:header:analytics', {
        detail: {
          event,
          location: 'header_search',
          page_type: this.dialog.dataset.tdPageType || '',
          query_length: this.input.value.trim().length,
          ...detail
        }
      }));
    }

    open(opener) {
      if (this.dialog.open) {
        this.input.focus({ preventScroll: true });
        return;
      }
      document.dispatchEvent(new CustomEvent('td:header:search-opening'));
      this.opener = opener;
      this.previousOverflowHidden = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('td-header-search-open', 'overflow-hidden');
      this.locked = true;
      this.dialog.showModal();
      document.querySelectorAll('[data-td-header-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.dispatchEvent(new CustomEvent('td:header:overlay-change', { detail: { open: true, source: 'search' } }));
      this.input.focus({ preventScroll: true });
      this.track('td_header_search_open');
      this.onInput();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.cleanup();
    }

    cleanup() {
      if (!this.locked) return;
      this.locked = false;
      clearTimeout(this.timer);
      this.request?.abort();
      this.sequence++;
      document.body.classList.remove('td-header-search-open');
      if (!this.previousOverflowHidden && !document.querySelector('dialog[open], cart-drawer.active')) {
        document.body.classList.remove('overflow-hidden');
      }
      document.querySelectorAll('[data-td-header-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.dispatchEvent(new CustomEvent('td:header:overlay-change', { detail: { open: false, source: 'search' } }));
      const target = this.opener?.getClientRects().length ? this.opener : Array.from(document.querySelectorAll('[data-td-header-search-open]')).find((element) => element.getClientRects().length);
      target?.focus({ preventScroll: true });
    }

    onClick(event) {
      if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }
      const product = event.target.closest('[data-td-search-product]');
      if (product) this.track('td_header_search_result_click', { product_id: product.dataset.tdSearchProduct, result_type: 'product' });
      const discovery = event.target.closest('[data-td-search-discovery]');
      if (discovery) this.track('td_header_search_result_click', { result_type: 'discovery', destination: discovery.dataset.tdSearchDiscovery });
      if (event.target.closest('[data-td-search-all]')) this.track('td_header_search_submit');
    }

    onSubmit(event) {
      const term = this.input.value.trim();
      if (!term) {
        event.preventDefault();
        this.input.focus();
        return;
      }
      this.track('td_header_search_submit');
      const canonical = normalize(term);
      if (canonical !== term) {
        event.preventDefault();
        const url = new URL(this.form.action, window.location.origin);
        url.search = new URLSearchParams(new FormData(this.form)).toString();
        url.searchParams.set('q', canonical);
        window.location.assign(url.toString());
      }
    }

    setAllLink(term) {
      const url = new URL(this.form.action, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      this.all.href = url.toString();
    }

    onInput() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.sequence++;
      const term = this.input.value.trim();
      this.clear.hidden = term.length === 0;
      this.results.hidden = true;
      this.results.setAttribute('aria-busy', 'false');
      this.discover.hidden = false;
      this.all.hidden = term.length === 0;
      this.status.textContent = '';
      if (!term) {
        this.results.replaceChildren();
        return;
      }
      const canonical = normalize(term);
      this.setAllLink(canonical);
      const sequence = this.sequence;
      this.timer = setTimeout(() => this.search(canonical, sequence), 180);
    }

    async search(term, sequence) {
      if (!this.dialog.open || sequence !== this.sequence) return;
      const cached = this.cache.get(term);
      if (cached && cached.expires > Date.now()) {
        this.render(cached.html, sequence);
        return;
      }
      this.cache.delete(term);
      this.request = new AbortController();
      this.results.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dialog.dataset.tdLoading;
      const url = new URL(this.dialog.dataset.tdSearchUrl, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('section_id', 'td-header-search-results');
      try {
        const response = await fetch(url.toString(), { signal: this.request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Predictive search unavailable');
        const html = await response.text();
        if (sequence !== this.sequence || !this.dialog.open) return;
        this.render(html, sequence);
        if (this.cache.size >= 12) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(term, { html, expires: Date.now() + 60000 });
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.status.textContent = this.dialog.dataset.tdErrorLabel;
        this.results.hidden = true;
        this.discover.hidden = false;
        this.results.setAttribute('aria-busy', 'false');
      }
    }

    render(html, sequence) {
      if (sequence !== this.sequence || !this.dialog.open) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('[data-td-search-response]');
      if (!content) throw new Error('Search response missing');
      content.querySelectorAll('script, iframe, object, embed').forEach((element) => element.remove());
      const candidates = Array.from(content.querySelectorAll('a[data-td-search-product]'));
      const queryWords = words(normalize(this.input.value));
      const titleMatches = queryWords.length ? candidates.filter((anchor) => {
        const titleWords = new Set(words(anchor.querySelector('.td-search__product-title')?.textContent || ''));
        return queryWords.every((word) => titleWords.has(word));
      }) : [];
      const displayed = new Set((titleMatches.length ? titleMatches : candidates).slice(0, 6));
      candidates.forEach((anchor) => {
        if (!displayed.has(anchor)) anchor.closest('li')?.remove();
      });
      const count = displayed.size;
      content.dataset.resultCount = String(count);
      content.querySelectorAll('a[data-td-original-url]').forEach((anchor) => {
        const target = new URL(anchor.getAttribute('href'), window.location.origin);
        const original = new URL(anchor.dataset.tdOriginalUrl, window.location.origin);
        if (target.origin !== window.location.origin || original.origin !== window.location.origin) return;
        ['_pos', '_psq', '_ss', '_v'].forEach((key) => {
          if (original.searchParams.has(key)) target.searchParams.set(key, original.searchParams.get(key));
        });
        anchor.href = target.pathname + target.search + target.hash;
        anchor.removeAttribute('data-td-original-url');
      });
      this.results.replaceChildren(document.importNode(content, true));
      this.results.hidden = false;
      this.results.setAttribute('aria-busy', 'false');
      this.discover.hidden = count > 0;
      this.status.textContent = count > 0 ? this.dialog.dataset.tdResultsLabel.replace('__COUNT__', String(count)) : this.dialog.dataset.tdNoResultsLabel;
      if (count === 0) this.track('td_header_search_zero_results', { result_count: 0 });
    }

    destroy() {
      if (this.dialog.open) this.dialog.close();
      this.cleanup();
      this.events.abort();
      this.request?.abort();
      clearTimeout(this.timer);
    }
  }

  let instance;
  const init = () => {
    const dialog = document.getElementById('td-header-search-dialog');
    if (!dialog || instance?.dialog === dialog) return;
    instance?.destroy();
    instance = new HeaderSearch(dialog);
  };
  window.tdHeaderSearchRuntime = { init };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-td-header-search-open]');
    if (!opener || !instance || typeof instance.dialog.showModal !== 'function') return;
    event.preventDefault();
    instance.open(opener);
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();
